"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectStyles = void 0;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const _1 = require("../.");
/**
 * A select dropdown, where user can pick only one option.
 */
const Select = ({ name, value, placeholder, mandatory, setValue, options, }) => {
    const classes = (0, exports.useSelectStyles)();
    return (react_1.default.createElement("select", { className: (0, classnames_1.default)(classes.select, 'rfc-input rfc-select'), name: name, value: value, onChange: e => setValue(name, e.target.value, mandatory, { touched: true }) },
        (!value || !mandatory) && react_1.default.createElement("option", { value: '', disabled: mandatory }, placeholder || (mandatory ? 'Select' : 'All')),
        options.map((option, index) => {
            const { optionLabel, optionValue } = (0, _1.parseOption)(option);
            return (react_1.default.createElement("option", { key: index, value: optionValue }, optionLabel));
        })));
};
exports.useSelectStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    select: {
        paddingRight: `35px !important`,
        cursor: 'pointer',
        // Remove default caret
        '-webkit-appearance': 'none',
        '&::-ms-expand': {
            display: 'none',
        },
        // Custom caret
        '&:not([multiple])': {
            backgroundImage: `linear-gradient(45deg,transparent 50%,${theme.colors.inputText} 0),linear-gradient(135deg,${theme.colors.inputText} 50%,transparent 0)`,
            backgroundSize: '5px 5px, 5px 5px',
            backgroundRepeat: 'no-repeat',
        },
        '&[multiple]': {
            height: 'auto',
        },
        '&:-webkit-autofill': {
            backgroundColor: `${theme.colors.inputBg} !important`,
            transition: 'background-color 5000s ease-in-out 0s',
        },
    },
}));
exports.default = (0, _1.withFormControl)(Select);
